import { NgModule, ModuleWithProviders, Provider } from '@angular/core';
import {
  GatewayConfig,
  GATEWAY_CONFIG,
  ExtGatewayConfig,
  EXT_GATEWAY_CONFIG,
} from './gateway.config';
import { GatewayConfig as SharedGatewayConfig } from '@cigna/shared/angular/gateways-util';

@NgModule({})
export class CignaForBrokersSharedGatewaysModule {
  static withConfig(
    config: GatewayConfig,
  ): ModuleWithProviders<CignaForBrokersSharedGatewaysModule> {
    return {
      ngModule: CignaForBrokersSharedGatewaysModule,
      providers: gatewaysProviders(config),
    };
  }
}
export function gatewaysProviders(config: GatewayConfig): Provider[] {
  return [{ provide: GATEWAY_CONFIG, useValue: config }];
}

export function extGatewaysProviders(config: ExtGatewayConfig): Provider[] {
  return [{ provide: EXT_GATEWAY_CONFIG, useValue: config }];
}

export function toSharedGatewaysConfig(
  _config: GatewayConfig,
): SharedGatewayConfig {
  return {
    cdn: '',
    resourceContent: '',
    directory: '',
    directoryTypeahead: '',
    directoryGeolocation: '',
    gsg: '',
    launchDarkly: '',

    eirAnalytics: '',
    elevateSurvey: '',
    communicationPreferencesUrl: '',
    publicLinkRouter: '',
    privateLinkRouter: '',
  };
}
